<template>
  <div class="text-center">
    <qrcode-vue v-if="urlQrcode != null" :value="urlQrcode" :size="size" level="L"></qrcode-vue>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "painel-qrcode",
  components: { QrcodeVue },
  props: {
    urlQrcode: { type: String, default: null },
    size: { type: Number, default: 200 }
  }
};
</script>
